import { useEffect, useState } from "react";
import { useAssessmentSession } from "../contexts/assessmentUserContext";
import {
  type DistrictOption,
  fetchDistricts,
} from "../services/appDistrictService";

export function useDistrictsFilter() {
  const { token } = useAssessmentSession();
  const [districts, setDistricts] = useState<DistrictOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setDistricts([]);
      setError(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const loadDistricts = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const nodes = await fetchDistricts(token);
        if (!cancelled) {
          setDistricts(nodes);
        }
      } catch (loadError: unknown) {
        if (!cancelled) {
          setDistricts([]);
          setError(
            loadError instanceof Error
              ? loadError.message
              : "Unable to load districts.",
          );
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadDistricts().then();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return { districts, isLoading, error };
}
